<script lang="ts">
  export let themed = false;
  export let fill = '';
</script>

<svg
  class="twism-close"
  class:twism-themed={themed}
  width="16"
  height="16"
  viewBox="0 0 12 12"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    {fill}
    d="M7.07667 6.00038L9.76755 3.30874C9.84025 3.23852 9.89824 3.15453 9.93814 3.06165C9.97803 2.96878 9.99903 2.8689 9.99991 2.76783C10.0008 2.66675 9.98153 2.56652 9.94325 2.47297C9.90498 2.37942 9.84846 2.29443 9.77699 2.22295C9.70551 2.15148 9.62052 2.09496 9.52697 2.05668C9.43342 2.01841 9.33319 1.99915 9.23211 2.00003C9.13104 2.00091 9.03116 2.02191 8.93828 2.0618C8.84541 2.10169 8.76142 2.15969 8.6912 2.23239L5.99956 4.92327L3.30868 2.23239C3.23846 2.15969 3.15446 2.10169 3.06159 2.0618C2.96872 2.02191 2.86884 2.00091 2.76776 2.00003C2.66669 1.99915 2.56646 2.01841 2.47291 2.05668C2.37936 2.09496 2.29436 2.15148 2.22289 2.22295C2.15142 2.29443 2.0949 2.37942 2.05662 2.47297C2.01835 2.56652 1.99909 2.66675 1.99997 2.76783C2.00085 2.8689 2.02184 2.96878 2.06174 3.06165C2.10163 3.15453 2.15962 3.23852 2.23233 3.30874L4.92321 5.99962L2.23233 8.69126C2.15962 8.76148 2.10163 8.84548 2.06174 8.93835C2.02184 9.03122 2.00085 9.1311 1.99997 9.23218C1.99909 9.33325 2.01835 9.43349 2.05662 9.52703C2.0949 9.62058 2.15142 9.70557 2.22289 9.77705C2.29436 9.84852 2.37936 9.90504 2.47291 9.94332C2.56646 9.98159 2.66669 10.0008 2.76776 9.99997C2.86884 9.99909 2.96872 9.97809 3.06159 9.9382C3.15446 9.89831 3.23846 9.84032 3.30868 9.76761L5.99956 7.07673L8.6912 9.76761C8.76142 9.84032 8.84541 9.89831 8.93828 9.9382C9.03116 9.97809 9.13104 9.99909 9.23211 9.99997C9.33319 10.0008 9.43342 9.98159 9.52697 9.94332C9.62052 9.90504 9.70551 9.84852 9.77699 9.77705C9.84846 9.70557 9.90498 9.62058 9.94325 9.52703C9.98153 9.43349 10.0008 9.33325 9.99991 9.23218C9.99903 9.1311 9.97803 9.03122 9.93814 8.93835C9.89824 8.84548 9.84025 8.76148 9.76755 8.69126L7.07667 5.99962V6.00038Z"
  /></svg
>

<style lang="scss">
  .twism-themed path {
    fill: var(--twism-theme-textAboveBackground) !important;
  }
</style>
